import { render, staticRenderFns } from "./SceneEdit.vue?vue&type=template&id=4b331681&"
import script from "./SceneEdit.vue?vue&type=script&lang=js&"
export * from "./SceneEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports